import React, { createContext, useState, useContext, useCallback } from "react";
import {apiInstance} from "../api/api";
// import { useAuthenticatedEffect } from "../components/useauthenticatedeffect";

const AccountingReportsContext = createContext();

export const useAccountingReports = () => useContext(AccountingReportsContext);

export const AccountingReportsProvider = ({ children }) => {
    const [balanceSheetData, setBalanceSheetData] = useState(null);
    const [incomeStatementData, setIncomeStatementData] = useState(null);
    const [trialBalanceData, setTrialBalanceData] = useState(null);

    const fetchBalanceSheet = useCallback(async (startDate, endDate) => {
        try {
            const response = await apiInstance.get("/reports/balance-sheet/", {
                params: { start_date: startDate, end_date: endDate }
            });
            setBalanceSheetData(response.data);
        } catch (error) {
            console.error("Error loading balance sheet data", error);
        }
    }, []);

    const fetchIncomeStatement = useCallback(async (startDate, endDate, financialYearId) => {
        try {
            const response = await apiInstance.get("/reports/income-statement/", {
                params: { start_date: startDate, end_date: endDate, financial_year_id: financialYearId }
            });
            setIncomeStatementData(response.data);
        } catch (error) {
            console.error("Error loading income statement data", error);
        }
    }, []);

    const fetchTrialBalance = useCallback(async (startDate, endDate) => {
        try {
            const response = await apiInstance.get("/reports/trial-balance/", {
                params: { start_date: startDate, end_date: endDate }
            });
            setTrialBalanceData(response.data);
        } catch (error) {
            console.error("Error loading trial balance data", error);
        }
    }, []);

    return (
        <AccountingReportsContext.Provider value={{ balanceSheetData, incomeStatementData, trialBalanceData, fetchBalanceSheet, fetchIncomeStatement, fetchTrialBalance }}>
            {children}
        </AccountingReportsContext.Provider>
    );
}